export enum LocalOrganizerTypeEnum {
  STUDENT = 'STUDENT',
  LEADER = 'LEADER'
}

export const localOrganizerTypeEnumMapping: Record<LocalOrganizerTypeEnum, string> = {
  [LocalOrganizerTypeEnum.STUDENT]: 'Student',
  [LocalOrganizerTypeEnum.LEADER]: 'Leader'
}
